import React from "react";
import { Form, Input } from "antd";
import useMultiNotification from "../../hooks/useNotification";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { updateEmailApi } from "../../redux-toolkit/slices/authSlice";
import { useSelector } from "react-redux";

export default function UpdateEmailForm() {
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();
  const { userProfile, isSubmitting } = useSelector(
    (state: RootState) => state.auth
  );
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      const { email, confirmEmail } = values;

      const data: IUpdateEmailApi = {
        email,
        confirmEmail,
      };

      console.log("Sending email update request:", data);
      const apiRes = await dispatch(updateEmailApi(data)).unwrap();
      console.log("Email update response:", apiRes);
      openNotification("success", "Success", apiRes.message || "Email updated successfully");
      form.resetFields();
    } catch (error) {
      console.error("Email update error:", error);
      if (typeof error === "string") {
        openNotification("error", "Update Failed", error);
      } else {
        openNotification("error", "Update Failed", "Server Error");
      }
    }
  };

  const validateConfirmEmail = ({ getFieldValue }: any) => ({
    validator(_: any, value: string) {
      if (!value || getFieldValue("email") === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("The emails do not match!"));
    },
  });

  return (
    <>
      {contextHolder}
      <div className="login-form-container rounded-3xl sm:rounded-[32px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden relative w-full" style={{ backgroundColor: "var(--neutral-100)" }}>
        <h3 className="h3 mb-3 w-full" style={{ textAlign: 'left' }}>
          Update Email
        </h3>
        
        {/* Description Text */}
        <div style={{ textAlign: 'left' }}>
          <p className="body1 mb-6">
            Change your email address to keep your account information current.
          </p>
        </div>

        {/* Wavy Line Separator */}
        <div className="flex justify-start mb-6">
          <svg viewBox="0 0 122 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[92px] md:w-[122px]">
            <path
              opacity="0.4"
              d="M1.46484 6.83613L4.45387 3.7103C7.74598 0.267505 13.38 0.760513 16.0241 4.72277L16.5428 5.50001C19.2423 9.54539 25.1877 9.54539 27.8873 5.5V5.5C30.5869 1.45461 36.5322 1.45461 39.2318 5.5V5.5C41.9314 9.54539 47.8768 9.54539 50.5764 5.5V5.5C53.2759 1.45461 59.2213 1.45461 61.9209 5.5V5.5C64.6205 9.54539 70.5658 9.54539 73.2654 5.5V5.5C75.965 1.45461 81.9104 1.45461 84.61 5.5V5.5C87.3096 9.54539 93.2549 9.54539 95.9545 5.5V5.5C98.6541 1.45461 104.599 1.45461 107.299 5.5V5.5C109.999 9.54539 115.944 9.54539 118.644 5.5L120.534 2.66667"
              stroke="var(--primary-500)"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <Form
          name="updateEmailForm"
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ remember: true }}
          requiredMark={false}
        >
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your new email address!",
              },
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
            ]}
          >
            <Input
              placeholder="New Email Address"
              type="email"
            />
          </Form.Item>

          <Form.Item
            name="confirmEmail"
            dependencies={["email"]}
            rules={[
              { required: true, message: "Please confirm your email address!" },
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
              validateConfirmEmail,
            ]}
          >
            <Input
              placeholder="Confirm Email Address"
              type="email"
            />
          </Form.Item>

          <Form.Item>
            <div className="flex justify-center">
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-primary btn-lg"
              >
                {isSubmitting ? "Updating..." : "Update Email"}
              </button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
}
